import React, { PureComponent } from 'react';
import { Input, Checkbox, Row } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import classNames from 'classnames/bind';
import { throttle } from 'lodash';

import Tags, { ITagProps } from 'src/components/DokTags';
import styles from './index.less';

const cx = classNames.bind(styles);
const { Search } = Input;

const defaultProps = {
  dataSource: [],
};
interface IProps {
  value: CheckboxValueType[];
  dataSource: ITagProps[];
  onChange?: (v: CheckboxValueType[]) => void;
}

export default class Group extends PureComponent<IProps> {
  static defaultProps = defaultProps;
  state = {
    search: '',
  };
  get isCheckedAll() {
    const { dataSource, value } = this.props;
    return dataSource?.length === value?.length
  }
  get indeterminate() {
    const { dataSource, value } = this.props;
    return value?.length !== 0 && value?.length < dataSource?.length
  }
  render() {
    const { dataSource, value = [] } = this.props;
    const { search, } = this.state;
    const onCheckAllChange = () => {
      //点击全选改变全选样式和数据
      if (this.isCheckedAll && !this.indeterminate) {
        this.handleChange([]);
        this.setState({ isCheckedAll: false });
      } else {
        this.handleChange(dataSource.map((c) => c.value));
        this.setState({ isCheckedAll: true });
      }
    };
    return (
      <>
        {dataSource && dataSource.length > 45 && (
          <Tags
            onChange={this.handleChange}
            dataSource={dataSource.filter((v) => (value || []).includes(v.value))}
          />
        )}
        {dataSource && dataSource.length > 45 && (
          <Search
            size="small"
            placeholder="搜索"
            allowClear
            onSearch={this.handleSearchChange}
            onChange={throttle((e) => this.handleSearchChange(e.target.value), 100)}
          />
        )}
        <Row className={styles['select-all']}>
          <Checkbox
            indeterminate={this.indeterminate}
            onChange={onCheckAllChange}
            checked={this.isCheckedAll}
            style={{
              display: !search ? 'initial' : 'none',
            }}
          >
            全选
          </Checkbox>
        </Row>

        <Checkbox.Group
          value={value}
          onChange={this.handleChange}
          className={cx(styles.group, { [styles.auto]: dataSource.length > 4 })}
        >
          {dataSource &&
            !!dataSource.length &&
            dataSource.map(({ label, value, name, isSelected, ...props }) => (
              <Row
                key={value}
                style={{
                  display:
                    !search || (label || name).toLowerCase().indexOf(search.toLowerCase()) > -1
                      ? 'initial'
                      : 'none',
                }}
              >
                <Checkbox value={value} {...props}>
                  {label || name}
                </Checkbox>
              </Row>
            ))}
        </Checkbox.Group>
      </>
    );
  }
  handleSearchChange = (search: string) =>
    this.setState({ search: (search || '').replace(/(^\s*)|(\s*$)/g, '') });
  handleChange = (val: CheckboxValueType[]) => {
    const { onChange } = this.props;
    onChange && onChange(val);
  };
}
